import React, { createContext, useCallback, useMemo, useRef } from 'react'

export type ChatShortcutsContextValue = {
  openQuickSearch: () => void
  registerOpenQuickSearch: (handler: (() => void) | null) => void
  lastSentMessage: string | undefined
}

const ChatShortcutsContext = createContext<ChatShortcutsContextValue | null>(null)

export function useChatShortcuts(): ChatShortcutsContextValue | null {
  return React.useContext(ChatShortcutsContext)
}

export interface ChatShortcutsProviderProps {
  lastSentMessage?: string
  children: React.ReactNode
}

export function ChatShortcutsProvider({ lastSentMessage, children }: ChatShortcutsProviderProps) {
  const openQuickSearchRef = useRef<(() => void) | null>(null)

  const registerOpenQuickSearch = useCallback((handler: (() => void) | null) => {
    openQuickSearchRef.current = handler
  }, [])

  const openQuickSearch = useCallback(() => {
    openQuickSearchRef.current?.()
  }, [])

  const value = useMemo<ChatShortcutsContextValue>(
    () => ({
      openQuickSearch,
      registerOpenQuickSearch,
      lastSentMessage,
    }),
    [openQuickSearch, registerOpenQuickSearch, lastSentMessage]
  )

  return <ChatShortcutsContext.Provider value={value}>{children}</ChatShortcutsContext.Provider>
}
